import { string, bool, shape, arrayOf, number } from 'react-proptypes';

let houseValueDefault = 300000;
const params = new URLSearchParams(window.location.search)
if (params.has('max_mortgage')) {
  houseValueDefault = params.get('max_mortgage');
}

let fixedRateTermDefault = 240;
if (params.has('frt')) {
  fixedRateTermDefault = Number(params.get('frt')) * 12;
}

let nhgDefault = false;
if (params.has('nhg')) {
  nhgDefault = Boolean(params.get('nhg'));
}

export default {
  app: 'looptijdrente',
  framed: false,
  syncing: false,
  broken: false,
  settings: null,
  input: {
    showAll: false,
    openForm: false,
    house_value: houseValueDefault,
    own_resources: null,
    fixed_rate_term: fixedRateTermDefault,
    has_nhg: nhgDefault,
    label_id: null,
  },
  output: {
    products: [],
    errors: {},
  },
};

export const whiteListUrlParams = [
  'fixed_rate_term',
  'has_nhg',
  'house_value',
  'label_id',
  'label_name',
  'own_resources',
];

export const resultLimit = 10;

export const shapeRateCorrection = shape({
  date: string.isRequired,
  payment_correction: number.isRequired,
  payment_after_correction: number.isRequired,
  rate_correction: number.isRequired,
  rate_after_correction: number.isRequired,
});

export const shapeResult = shape({
  initial_interest_rate: number.isRequired,
  average_interest_rate: number.isRequired,
  first_monthly_payment: number.isRequired,
  average_monthly_payment: number.isRequired,
  has_automatic_risk_class_reduction: bool,
  rate_corrections: arrayOf(shapeRateCorrection),
});
